import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SimuService} from './simu.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  exports: [],
  providers: [
    SimuService,
  ]
})
export class SimuModule {
}
